// ~~ Generated. This file cannot be edited directly. Please look at libs/nx-tooling/src/generators/backoffice-project/generator.ts

import { loadLazyWithTimeoutRetry } from '@backoffice-frontend/lazy-loading'
import { SuspenseLoadingWrapper } from '@backoffice-frontend/patterns'
import { BoumRight } from '@moia-dev/moia-token-claims'
import { lazy } from 'react'
import { ServiceBreakLocationsAreaId } from './ServiceBreakLocationsAreaId'
import { ServiceBreakLocationsAreaNavigation } from './ServiceBreakLocationsAreaNavigation'
import { ServiceBreakLocationsAreaRoutes } from './ServiceBreakLocationsAreaRoutes'

const LazyServiceBreakLocationsComponent = lazy(() =>
  loadLazyWithTimeoutRetry(() => import('./ServiceBreakLocationsArea')),
)

const ServiceBreakLocationsComponent = () => (
  <SuspenseLoadingWrapper>
    <LazyServiceBreakLocationsComponent />
  </SuspenseLoadingWrapper>
)

export const ServiceBreakLocationsArea = {
  id: ServiceBreakLocationsAreaId,
  requiredRight: BoumRight.DEV_USE_FEATURE_TOGGLES,
  NavigationComponent: ServiceBreakLocationsAreaNavigation,
  route: {
    path: ServiceBreakLocationsAreaRoutes.route,
    component: ServiceBreakLocationsComponent,
  },
}
